var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pillbox"},_vm._l((_vm.items),function(v){return _c('checkpill',{key:v.id,attrs:{"title":v.text,"checked":_vm.isSelected(v.id)},on:{"click":_vm.onClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }